import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CountryDto, ContinentDto} from '@cradua/data';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-country-container',
  templateUrl: './country-container.component.html',
  styleUrls: ['./country-container.component.scss']
})
export class CountryContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  continents$: Observable<ContinentDto[]>;
  countries$: Observable<CountryDto[]>;
  loading: boolean;
  isLoadingContinent$: Observable<boolean>;
  isLoadingCountry$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingContinent$ = this.gatwayFacade.isLoadingGateway("Continent");
    this.isLoadingCountry$ = this.gatwayFacade.isLoadingGateway("Country");

    this.continents$ = this.gatwayFacade.loadGateway("Continent");
    this.countries$ = this.gatwayFacade.loadGateway("Country");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteCountry(deletedValue: any) {
    this.gatwayFacade.remove("Country", deletedValue);
  }

// this method control both the create and update
  onSubmitCountry(formValue: any) {
    const pullData = formValue.Countries;

// declare two empty array to hold update and create data
  const allUpdates = [] ;
  const addAllCountry = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      addAllCountry.push(pullData[i]);
    }
  }

// check if the addAllCountry array is not empty, then dispatch the data to the store
   if(addAllCountry.length > 0) {
    this.gatwayFacade.add('Country', addAllCountry);
   }

// dispatch update data to the store
   if(allUpdates.length > 0) {
    this.gatwayFacade.update('Country', allUpdates, ['id']);
   }
  }


}
